<template>
  <div>
    <div class="card">
      <div class="card-top">
        <span></span>
        <h3>代客充值</h3>
      </div>
      <el-tabs v-model="activeName">
        <div  >
          <el-form ref="ruleForm" :model="formData" :rules="rules" label-width="100px">
            <el-form-item label="客户名称：" prop="custName">
              <el-input v-model="formData.custName"  style="width:500px;"     @focus="changeMember"></el-input>
            </el-form-item>
            <el-form-item label="付款方式：" prop="payType">
              <el-select v-model="formData.payType" placeholder="请选择付款方式"  style="width:500px;">
                <el-option label="微信" value="1"></el-option>
                <el-option label="支付宝" value="2"></el-option>
                <el-option label="对公转账" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="充值日期：" prop="payDate">
              <el-date-picker
                  v-model="formData.payDate"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 500px;"
              />
            </el-form-item>
            <el-form-item label="充值金额：" prop="fee">
              <el-input    v-model="formData.fee"    @input="handleInput"
                                  @blur="handleBlur"
                                  @keydown.native="handleKeyDown"  style="width:500px;" ></el-input>
            </el-form-item>
            <el-form-item label="充值密码：" prop="payPwd">
              <el-input    v-model="formData.payPwd"  show-password   style="width:500px;" ></el-input>
            </el-form-item>
            <el-form-item label="充值说明：" prop="remark">
              <el-input type="textarea"  :rows="5"   style="width:500px;" v-model="formData.remark" ></el-input>
            </el-form-item>

          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="cancle">取 消</el-button>
            <el-button type="primary" @click="sureAdd">确 定</el-button>
          </div>

        </div>
      </el-tabs>
    </div>
    <el-dialog :close-on-click-modal="false" title="选择客户" :visible.sync="dialogVisible">
      <div class="queryMember">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input
                v-model.trim="custName1"
                placeholder="请输入用户名称"
            ></el-input
            >
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="getCustomer">查询</el-button>

          </el-col>
        </el-row>
      </div>
      <el-table
          :data="allmemberList"
          border
          style="width: 100%"
          class="memberTable"
      >
        <el-table-column header-align="center" align="center" width="100">
          <template scope="scope">
            <el-radio
                :label="scope.row.user_ID"
                v-model="radioMember"
                style="width:50px;"
                @change.native="getCurrentRow(scope.row)"
            ></el-radio>
          </template>
        </el-table-column>

        <el-table-column
            property="name"
            label="用户名称"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            label="联系方式"
            width="180"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            <span>{{scope.row.phone ? scope.row.phone : scope.row.username}}</span>
          </template>
        </el-table-column>
        <el-table-column
            property="createTime"
            label="注册时间"
            width="200"
            header-align="center"
            align="center"
        >
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNumber"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
                        <el-button @click="cancelChange">取 消</el-button>
                        <el-button type="primary" @click="sureChange">确 定</el-button>
                    </span>
    </el-dialog>
  </div>


</template>

<script>
import api from "../../api/webAdmin/webAdmin";

export default {
  name: "daikepay",
  data() {
    return {
      custName1: '',
      activeName: '1',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      allmemberList: [],
      dialogVisible: false,
      radioMember: "",
      usertype: "",
      prevValue:"",
      //公司信息
      formData: {
        payType: "",
        payDate: "",
        fee: '',
        remark: '',
        custName: "", // 客户名称
        userId: "", // 客户ID

        payPwd: ''
      },
      rules: {
        custName: [
          {required: true, message: "请输入客户名称", trigger: "blur"},
        ],
        payType: [
          {required: true, message: "请选择付款方式", trigger: "change"},
        ],
        payDate: [
          {required: true, message: "请选择充值日期", trigger: "change"},
        ],
        fee: [
          {required: true, message: "请输入充值金额", trigger: "blur"},
        ],
        remark: [
          {required: true, message: "请输入充值说明", trigger: "blur"},
        ],
        payPwd: [
          {required: true, message: "请输入充值密码", trigger: "blur"},
        ],
      },
    }
  },
  created() {
    let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
    this.usertype = obj.userType;
    this. getCurrentDay();
  },
  methods: {
    handleInput(value) {
      // 正则表达式匹配：
      // 1. 空字符串
      // 2. 负号
      // 3. 整数
      // 4. 带1-2位小数的数字
      const regex = /^(-|-\d*|\d*|-\d*\.\d{0,2}|\d*\.\d{0,2})$/;

      if (regex.test(value)) {
        this.prevValue = value;
      } else {
        // 恢复为上一次有效的值
        this.$nextTick(() => {
          this.formData.fee = this.prevValue;
        });
      }
    },

    // 处理失去焦点事件，进行最终验证和格式化
    handleBlur() {
      if (this.formData.fee === '-' || this.formData.fee === '') {
        this.formData.fee = '';
        return;
      }

      // 格式化数字，确保有两位小数
      if (this.formData.fee.includes('.')) {
        const parts = this.formData.fee.split('.');
        if (parts[1].length === 1) {
          this.formData.fee = `${parts[0]}.${parts[1]}0`;
        }
      } else if (this.formData.fee !== '') {
        this.formData.fee = `${this.formData.fee}.00`;
      }
    },

    // 处理键盘事件，阻止非法字符输入
    handleKeyDown(e) {
      // 允许的功能键
      const allowedKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
        'Tab', 'Home', 'End'
      ];

      // 如果按下了允许的功能键，直接返回
      if (allowedKeys.includes(e.key)) {
        return;
      }

      // 允许的字符：数字、小数点、负号
      const allowedChars = /[\d\.\-]/;

      // 如果按下的键不是允许的字符，阻止输入
      if (!allowedChars.test(e.key)) {
        e.preventDefault();
        return;
      }

      // 特殊处理负号和小数点
      const currentValue = this.formData.fee;
      const selectionStart = e.target.selectionStart;

      // 负号只能出现在开头
      if (e.key === '-' && selectionStart !== 0) {
        e.preventDefault();
        return;
      }

      // 只能有一个负号
      if (e.key === '-' && currentValue.includes('-')) {
        e.preventDefault();
        return;
      }

      // 只能有一个小数点
      if (e.key === '.' && currentValue.includes('.')) {
        e.preventDefault();
        return;
      }

      // 小数点后不能超过两位
      if (currentValue.includes('.')) {
        const decimalPart = currentValue.split('.')[1];
        if (decimalPart && decimalPart.length >= 2 &&
            e.target.selectionStart > currentValue.indexOf('.')) {
          e.preventDefault();
          return;
        }
      }
    },
    getCurrentDay() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      month = (month > 9) ? month : ('0' + month)
      day = (day < 10) ? ('0' + day) : day
      this.formData.payDate = year + '-' + month + '-' + day
    },
    // 单选
    getCurrentRow(item) {
      this.formData.userId = item.user_ID;
      this.formData.custName = item.name + '(' + item.phone + ')';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCustomer();
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getCustomer();
    },
    changeMember() {
      this.custName1 = "";
      this.dialogVisible = true;
      this.getCustomer();
    },


    sureChange() {
      if (this.radioMember === "") {
        this.$message.warning("请选择客户！");
        return;
      }
      // this.radioMember = "";
      this.dialogVisible = false;
    },

    cancelChange() {
      this.radioMember = "";
      this.formData.userId = "";
      this.formData.custName = "";
      this.custName1 = "";
      this.dialogVisible = false;
    },

    getCustomer() {
      api.queryUser(this.pageNumber, this.pageSize, "", "", this.custName1, this.usertype).then((res) => {
        console.log("获取客户", res);
        if (res.success) {
          this.allmemberList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 清空表单
    clearFrom() {
       this.formData = {
        payType: "",
        payDate: "",
        fee: "",
         remark: '',
        custName: "", // 客户名称
        userId: "", // 客户ID
      };
       this.custName1 = "";

    },
    //取消
    cancle() {
      this.clearFrom();
    },
    // 新增
    sureAdd() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$http.post("/user/payPwd/check?payPwd=" + this.formData.payPwd).then((res) => {
            if (res.data.code == 200) {
              this.$http.post("/usewallet/addMoney", this.formData).then((res) => {
                if (res.data.code == 200) {

                  this.$message({
                    message: "充值成功,请到充值流水菜单中查看充值记录！",
                    type: "warning",
                    duration: 10000
                  });
                  this.clearFrom();

                } else {
                  this.$message.error("充值失败");

                }
              }).catch((error) => {
                this.$message.error("充值失败");
              });
            }else {
              this.$message.error(res.data.message);
            }
          }).catch((error) => {
            this.$message.error("密码校验失败失败");
          });
        }
      })
    },


  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/*富文本高度*/
.w-e-text-container {
  height: 140px !important;
}

.w-e-toolbar .w-e-menu {
  width: 30px !important;
  height: 30px !important;
}

.fwb {
  .el-form-item__content > div {
    width: 100% !important;
  }
}

.el-form-item__content {
  /*#wangEditor-1,#wangEditor-2,#wangEditor-3{*/
  /*    width: 100% !important;*/
  /*}*/
  #wangEditor-2 {
    width: 100% !important;
  }

  #wangEditor-3 {
    width: 100% !important;
  }
}


/*客服QQ*/
.el-form-item__content {
  display: flex;
  /*justify-content: space-between;*/
  .el-input {
    width: auto;
    /*margin-right: 24px;*/
  }
}
</style>
<style lang="scss" scoped>
.card {
  width: 100%;

  .card-top {
    display: flex;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #e6e6e6;
    padding: 0 30px;
    line-height: 50px;

    span {
      display: inline-block;
      width: 5px;
      height: 17px;
      background: #058af2;
      margin-right: 20px;
    }

    h3 {
      color: #058af2;
    }
  }

  .tab {
    padding: 10px;

    .tap {
      margin-bottom: 10px;
    }
  }

  .page {
    margin-top: 20px;
  }
}
</style>
